import apiClient from '../util/apiClient'
import changeCaseObject from 'change-case-object'
import { getAuthHeaders } from '../../auth'

export const clientOptions = {
  contentType: 'application/json',
  transformRequest: [
    function (data, headers) {
      Object.assign(headers, getAuthHeaders())
      return JSON.stringify(data)
    },
  ],
  transformResponse: [
    function (data) {
      // Convert JsonAPI's default kebab-case to camelCase for easier destructuring in Javascript
      let parsedData = null

      try {
        parsedData = changeCaseObject.camelCase(JSON.parse(data))
      } catch (e) {}

      return parsedData || data
    },
  ],
}

const client = apiClient(process.env.REACT_APP_NODE_API_URL, clientOptions)

// This is a workaround to strip auth headers off specified requests
client.noAuthorization = apiClient(process.env.REACT_APP_NODE_API_URL, {
  ...clientOptions,
  transformRequest: [
    function (data) {
      return JSON.stringify(data)
    },
  ],
})

export default client
